import useGetItem from "./hooks/useGetItem";
import useUpdate from "./hooks/useUpdate";
import { GenericMethods } from "layouts/aplicacoes/GenericMethods";
import { SchemaData } from "./hooks/types";
import { UpdateGql } from "./queries/update";
import { Contact } from ".";
import { UpdateArgsProps } from "./types";

function Update({ slug, path, siteId }: UpdateArgsProps) {
  return (
    <GenericMethods.Update<SchemaData, UpdateGql>
      siteId={siteId}
      sitePath={path}
      redirectPath={`${path}/forms`}
      hideDeleteButton={true}
      useGetItem={useGetItem}
      useUpdate={useUpdate}
      queryParam={slug}
      updatePermission={Contact.Permissions.update}
      deletePermission={Contact.Permissions.delete}
    />
  );
}

export default Update;
